var map = {
	"./del.svg": "6425",
	"./depart-selected.svg": "435a",
	"./depart.svg": "165c",
	"./female-selected.svg": "0f44",
	"./female.svg": "4d9c",
	"./male-selected.svg": "c190",
	"./male.svg": "e8bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2920";